/** Keep selected tabs visible after navigation, selection, or viewport changes. */
export function installMobileTabVisibility() {
  let frame = 0;
  const reveal = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      document.querySelectorAll<HTMLElement>('[role="tablist"]').forEach(list => {
        const selected = list.querySelector<HTMLElement>(':scope > [role="tab"][aria-selected="true"]');
        if (!selected || !list.clientWidth || list.scrollWidth <= list.clientWidth) return;
        const bounds = list.getBoundingClientRect();
        const tab = selected.getBoundingClientRect();
        const delta = tab.left < bounds.left + 5 ? tab.left - bounds.left - 5
          : tab.right > bounds.right - 5 ? tab.right - bounds.right + 5 : 0;
        if (delta) list.scrollBy({ left: delta, behavior: 'instant' });
      });
    });
  };
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes'
      ? record.target instanceof Element && record.target.matches('[role="tab"]')
      : [...record.addedNodes].some(node => node instanceof Element && (node.matches('[role="tablist"], [role="tab"]') || node.querySelector('[role="tablist"]'))))) reveal();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
  window.addEventListener('resize', reveal);
  void document.fonts.ready.then(reveal);
}
